document.addEventListener("DOMContentLoaded", function () {
    // Get all input fields with the 'custom-input' class
    const inputFields = document.querySelectorAll('.custom-input');
  
    // Variable to store the index of the currently focused input field
    let currentIndex = 0;
  
    // Add an input event listener to each input field
    inputFields.forEach((input, index) => {
      input.addEventListener('compositionstart', function () {
        // Set a flag when composition (Pinyin input) starts
        input.isComposing = true;
      });
  
      input.addEventListener('compositionend', function () {
        // When composition ends, move focus if necessary
        input.isComposing = false;
        if (currentIndex < inputFields.length - 1) {
          inputFields[currentIndex + 1].focus();
        }
      });
  
      input.addEventListener('input', function () {
        if (!input.isComposing) {
          // Handle regular input events (non-composition)
          const pinyinLength = input.value.replace(/[^a-zA-Z]/g, '').length;
  
          if (pinyinLength === 1) {
            // Move focus to the next input field if one Pinyin character is typed
            currentIndex = index;
            if (currentIndex < inputFields.length - 1) {
              inputFields[currentIndex + 1].focus();
            }
          } else if (pinyinLength === 0) {
            // Move focus to the previous input field if a Pinyin character is deleted
            currentIndex = index;
            if (currentIndex > 0) {
              inputFields[currentIndex - 1].focus();
            }
          }
        }
      });
  
      // Add a keydown event listener for arrow key navigation
      input.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'Tab') {
          // Move focus to the next input field
          currentIndex = index;
          if (currentIndex < inputFields.length - 1) {
            inputFields[currentIndex + 1].focus();
          }
          event.preventDefault();
        } else if (event.key === 'ArrowLeft' && currentIndex > 0) {
          // Move focus to the previous input field
          currentIndex = index;
          inputFields[currentIndex - 1].focus();
          event.preventDefault();
        }
      });
    });
  });
  //Stamp Style Selector
  
  var prodId;
  var boxIndex;
  var assetURL;
  var styleNam;
  var chkD;
  
  
  addActiveClass('.option_sty');
  addActiveClass('.option_sty__b');
  
  function checkNames(prodId, loopN, imUr, stlN, dobSt) {
     const styleBoxID = `styleOption--${loopN}--${prodId}`;
   
     console.log(prodId);
     console.log(loopN);
     console.log(imUr);
     console.log(stlN);
     console.log(dobSt);
     console.log('------');
   
     if (!dobSt) {
       addActiveClass('.option_sty');
       extractStyleName(stlN);
       console.log("A side Selected");
     } else {
       console.log("B side Selected");
       addActiveClass('.option_sty__b');
       extractStyleNameB(stlN);
     }
     addActiveClass('.option_sty');
     addActiveClass('.option_sty__b');
   }
   
   function addActiveClass(selector) {
     const optionStys = document.querySelectorAll(selector);
   
     optionStys.forEach(optionSty => {
       optionSty.addEventListener('click', () => {
         optionStys.forEach(os => os.classList.remove('active-style'));
         optionSty.classList.add('active-style');
       });
     });
   }
   
   function extractStyleNameB(styleNameB) {
     const styleNamB = styleNameB;
     $(".inputBoxB").val(val => styleNamB);
     console.log('nombre estilo: ' + styleNamB);
     console.log('valor de inputBox: ' + $(".inputBoxB").val());
   }
   
   function extractStyleName(styleNam) {
     $(".inputBox").val(val => styleNam);
     console.log('nombre estilo: ' + styleNam);
     console.log('valor de inputBox: ' + $(".inputBox").val());
   }
  